import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';
import { useContextSelector as useCS } from 'use-context-selector';
import { TUpdate } from 'domain/types';
import {
  GlobalConfigContext,
  TGlobalConfigContextState,
} from 'domain/globalConfig/GlobalConfigContext';
import { globalConfigSelectors } from 'domain/globalConfig/selectors';

export const useUpdateJobPostStatus = (): any => {
  const update: TUpdate<TGlobalConfigContextState> | undefined = useCS(
    GlobalConfigContext,
    globalConfigSelectors.update
  );

  const { data, isLoading, send } = useRequest({
    /* url: `/api/v1/jobPosts/${jobPostId}`, */
    method: ApiMethodsEnum.Patch,
    sendOnStart: false,
  });

  const updateJobPostStatus = (body, jobPostId, successFunction) => {
    send(body, `/api/v1/jobPosts/${jobPostId}`).then((res) => {
      if (update)
        update({
          isOpenMoveJobPostToDraftModal: false,
          jobPostIdToDraft: null,
          isOpenMoveJobPostToActiveModal: false,
          jobPostIdToActive: null,
        });
      successFunction();
    });
  };

  return {
    isLoading,
    updateJobPostStatus,
    data,
  };
};
